import { useTranslation } from 'react-i18next';

// Shared prev/next pager. `page` is zero-based.
export default function Paginator({ page, totalPages, onPage }) {
  const { t } = useTranslation();
  return (
    <nav className="mt-8 flex items-center justify-center gap-2 text-sm">
      <button
        type="button"
        className="btn-ghost px-3 py-1 text-sm disabled:cursor-not-allowed disabled:opacity-40"
        onClick={() => onPage(Math.max(0, page - 1))}
        disabled={page === 0}
      >
        ← {t('common.back')}
      </button>
      <span className="px-3 text-ink-secondary">
        {page + 1} / {totalPages}
      </span>
      <button
        type="button"
        className="btn-ghost px-3 py-1 text-sm disabled:cursor-not-allowed disabled:opacity-40"
        onClick={() => onPage(Math.min(totalPages - 1, page + 1))}
        disabled={page >= totalPages - 1}
      >
        {t('common.next')} →
      </button>
    </nav>
  );
}
